import { render, staticRenderFns } from "./ImportBatches.vue?vue&type=template&id=94c3056e&scoped=true&"
import script from "./ImportBatches.vue?vue&type=script&lang=ts&"
export * from "./ImportBatches.vue?vue&type=script&lang=ts&"
import style0 from "./ImportBatches.vue?vue&type=style&index=0&id=94c3056e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c3056e",
  null
  
)

export default component.exports